// extracted by mini-css-extract-plugin
module.exports = {"antRow":"TeamCollab_antRow__AtzG5","addForm":"TeamCollab_addForm__3Z6uf"};